import React from 'react'
import { Box } from 'grommet'

import Layout from '../../components/layout'
import SEO from '../../components/seo'
import FormArtFiles from '../../components/FormArtFiles'

const LettersDesign = () => (
  <Layout productNav="letters">
    <SEO title="Letters - Design" />
    <Box pad={{ vertical: 'medium' }} fill>
      <FormArtFiles product="letters" />
    </Box>
  </Layout>
)

export default LettersDesign
